module.exports = __webpack_public_path__ + "img/not-found.4c02eb7.png";